import React, { FC, useMemo } from 'react';
import { SelectProps } from 'formik-antd/src/select/index';
import { Select } from 'formik-antd';
import { DeviceModeType } from 'models/higoDevice';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const ModeSelect: FC<SelectProps> = (props) => {
  const intlMessage = useFormatMessage();
  const options = useMemo(
    () => (
      <>
        <Select.Option key={'both'} value={'both'}>
          {intlMessage({ id: 'both' })}
        </Select.Option>
        {Object.values(DeviceModeType).map((x: any) => (
          <Select.Option key={x} value={x}>
            {x === 'FAMILY_MODE' && 'Family'}
            {x === 'PRO_MODE' && 'Pro'}
          </Select.Option>
        ))}
      </>
    ),
    [intlMessage]
  );

  return <Select {...props}>{options}</Select>;
};
